import { FC } from 'react';
import MetroBuildingImage from '../../../../../assets/images/metro/game/MetroBuilding.svg';
import DoorOpenImage from '../../../../../assets/images/metro/game/OpenDoor.svg';
import DoorCloseImage from '../../../../../assets/images/metro/game/CloseDoor.svg';
import styles from './styles.module.scss';
import classNames from 'classnames';

type Props = {
  className?: string;
  isLeftOpenDoor?: boolean;
  isRightOpenDoor?: boolean;
};

const MetroBuilding: FC<Props> = ({ className, isLeftOpenDoor, isRightOpenDoor }) => {
  return (
    <div className={classNames(styles.metroBuilding, className)}>
      <img src={MetroBuildingImage} className={styles.main} alt="" />

      <div className={classNames(styles.leftDoor, { [styles.open]: isLeftOpenDoor }, 'leftDoor')}>
        {isLeftOpenDoor ? (
          <img src={DoorOpenImage} className={classNames(styles.open, 'open')} alt="" />
        ) : (
          <img src={DoorCloseImage} className={classNames(styles.close, 'closed')} alt="" />
        )}
      </div>

      <div className={classNames(styles.rightDoor, { [styles.open]: isRightOpenDoor }, 'rightDoor')}>
        {isRightOpenDoor ? (
          <img src={DoorOpenImage} className={classNames(styles.open, 'open')} alt="" />
        ) : (
          <img src={DoorCloseImage} className={classNames(styles.close, 'closed')} alt="" />
        )}
      </div>
    </div>
  );
};

export default MetroBuilding;
